import { Drawer } from "antd";
import { Children } from "react";
import dayjs from "dayjs";

import { BarChartOutlined } from "@ant-design/icons";
import workIcon from "@/assets/images/icons/work.png";
import calendarIcon from "@/assets/images/icons/calendar.png";
export default function CalendarDrawer(props) {
  const { open, onClose, calendarData, month } = props;

  // console.log("calendarData", calendarData);

  const title = month
    ? dayjs(month, "YYYY-MM").locale("en").format("MMMM,YYYY")
    : "Calendar Detail";

  const formatPeriodRange = (start, end) => {
    if (!start || !end || start.length < 3 || end.length < 3) {
      return "--/--";
    }

    const startDate = dayjs(
      `${start[0]}-${String(start[1]).padStart(2, "0")}-${String(
        start[2],
      ).padStart(2, "0")}`,
    );

    const endDate = dayjs(
      `${end[0]}-${String(end[1]).padStart(2, "0")}-${String(end[2]).padStart(
        2,
        "0",
      )}`,
    );

    return `${startDate.format("MM/DD")}-${endDate.format("MM/DD")}`;
  };

  return (
    <Drawer
      title={
        <span
          style={{
            fontSize: 22,
            color: "#2463EA",
            lineHeight: "26px",
            textAlign: "left",
            fontStyle: "normal",
          }}
        >
          {title}
        </span>
      }
      open={open}
      onClose={onClose}
      width={620}
      destroyOnClose
    >
      <div className="calendar-content">
        <div className="work">
          <div className="header">
            <img src={workIcon} alt="work" style={{ width: 20, height: 20 }} />
            <div className="title">Work hours statistics</div>
          </div>
          <div className="workTotal">
            <div className="workTotalName">Total working hours</div>
            <div className="workTotalNum">
              {" "}
              {calendarData?.currentMonthWorkHours ?? 0}h
            </div>
            <div className="work_week">
              <div className="firstHalf">
                <div>
                  <div>
                    {" "}
                    {formatPeriodRange(
                      calendarData?.periodWorkHours?.firstHalf?.startDate,
                      calendarData?.periodWorkHours?.firstHalf?.endDate,
                    )}
                  </div>
                  <div className="half_hours">
                    {calendarData?.periodWorkHours?.firstHalf?.workHours ?? 0}h
                  </div>
                </div>
                <img
                  src={calendarIcon}
                  alt="work"
                  style={{ width: 54, height: 54 }}
                />
              </div>
              <div className="firstHalf">
                <div>
                  <div>
                    {" "}
                    {formatPeriodRange(
                      calendarData?.periodWorkHours?.fullMonth?.startDate,
                      calendarData?.periodWorkHours?.fullMonth?.endDate,
                    )}
                  </div>
                  <div className="half_hours">
                    {calendarData?.periodWorkHours?.fullMonth?.workHours ?? 0}h
                  </div>
                </div>
                <img
                  src={calendarIcon}
                  alt="work"
                  style={{ width: 54, height: 54 }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="week">
          <div className="title">Weekly working hours statistics</div>
        </div>
      </div>
    </Drawer>
  );
}
